import { ReactElement } from 'react';

import { TranslatableText } from '@dreryk/react-common';
import { Dropdown } from '@dreryk/react-components';

import { VisitCancelShowModalEventInterceptor } from '~libs.desktop.shared.visit-cancel';

type AppointmentCancelDropdownItemProps = {
   readonly appointmentId: number;
   readonly refetchPrescriptionVisits: VoidFunction;
   readonly label: TranslatableText;
   readonly disabled: boolean;
};

export const AppointmentCancelDropdownItem = (props: AppointmentCancelDropdownItemProps): ReactElement => {
   const handleClick = (hide: VoidFunction): void => {
      hide();
   };

   return (
      <VisitCancelShowModalEventInterceptor
         cancellable={!props.disabled}
         appointmentId={props.appointmentId}
         onSuccess={props.refetchPrescriptionVisits}
         onFault={props.refetchPrescriptionVisits}
      >
         <Dropdown.Item
            testId={`appointmentCancelOption${props.appointmentId}`}
            onClick={handleClick}
            disabled={props.disabled}
         >
            {props.label}
         </Dropdown.Item>
      </VisitCancelShowModalEventInterceptor>
   );
};
